<template>
  <div>
    <strong>{{ feed.from }}</strong>: {{ feed.subject }}
    <br/>
    <iframe :id="id" src="about:blank"></iframe>
  </div>
</template>

<style scoped>
.feed-item {
  padding: 1em;
}
iframe {
  width: 600px;
}
</style>
<script>

export default {
  name: "feedItem",
  props: { feed: Object },
  data () {
    return { id: null }
  },
  created () {
    this.id = 'body-' + this._uid;
  },
  mounted () {
    var doc = document.getElementById(this.id).contentWindow.document;
    doc.open();
    doc.write(this.feed.html);
    doc.close();
  }
};
</script>
